/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../bootstrap';
import '../plugins';
import Vue from 'vue';

import './socialite-google';

window.Vue = Vue;

/**
 * Vue is available globally for any page that needs it.
 * Individual pages should mount their own Vue instances as needed.
 * The runtime-only build is used to avoid CSP eval() issues.
 */
